// @flow
const TOKEN_KEY = 'fa_token';

export default class Cache {

  /** ** Authorization Token Helpers **** */

  static clearToken() {
    localStorage.removeItem(TOKEN_KEY);
  }

  static getAccessToken() {
    return localStorage.getItem(TOKEN_KEY);
  }

  static setAccessToken(token: string) {
    localStorage.setItem(TOKEN_KEY, token);
    return token;
  }

  static setTokenExpiration(timestamp: number) {
    localStorage.setItem('tokenExpiration', timestamp);
  }

  static getTokenExpiration() {
    return localStorage.getItem('tokenExpiration');
  }

  static saveUserRequestedHref(url) {
    localStorage.setItem('loginHref', url);
  }

  static getUserRequestedHref() {
    return localStorage.getItem('loginHref');
  }

  static clearUserRequestedHref() {
    localStorage.removeItem('loginHref');
  }
}